import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environment/environment';

import { AppModule } from './app/app.module';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.log(err));

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/firebase-messaging-sw.js')
		.then(function (registration) {
			console.log('Firebase Worker Registered');
		})
		.catch(function (err) {
			console.log('Service Worker registration failed: ', err);
		});
}

// load segment bundle
/*
 * script to load segment library from assets folder
 * to get these files, run app locally and find all files requested by segment appling key, ~ 4 files are:
 * analytics.min.js (this file in requests two other scripts in)
 * 130.bundle.55742ac9337d9e12bdd6.js
 * ajs-destination.bundle.36b90a11867ae217be52.js
 * settings
 * in analytics.min.js file update url http://apisegment.cargochief.com/v1 with the proxt url (for posting segment event)
 * in analytics.min.js file update url for all the files requested by script to load from local
 */
const script = document.createElement('script');
script.innerHTML = `
	!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="`+ `${environment.production ? 'assets/seg/prod/a-min.js' : 'assets/seg/dev/a-min.js'}` +`";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${environment.SEGMENT_KEY}";analytics._cdn="${environment.SEGMENT_PROXY}";analytics.SNIPPET_VERSION="4.15.2";
	analytics.load("${environment.SEGMENT_KEY}");
	analytics.page();
	}}();
`;
document.head.appendChild(script);
